/** Shopify CDN: Minification failed

Line 13:4 Transforming const to the configured target environment ("es5") is not supported yet

**/
/** ↴ ↴ ↴ ↴ ↴ ↴ ↴ ↴ ↴ ↴ ↴ ↴ Start ↴ ↴ ↴ ↴ ↴ ↴ ↴ ↴ ↴ ↴ ↴   **/

/** ✿ ✿ ✿ ✿ ✿ ✿ ✿ CHANGE STYLES ON SCROLL ✿ ✿ ✿ ✿ ✿ ✿ ✿  **/
/** ✿ ✿ ✿ ✿ ✿ ✿ ✿ CHANGE STYLES ON SCROLL ✿ ✿ ✿ ✿ ✿ ✿ ✿  **/
/** ✿ ✿ ✿ ✿ ✿ ✿ ✿ CHANGE STYLES ON SCROLL ✿ ✿ ✿ ✿ ✿ ✿ ✿  **/
/** ✿ ✿ ✿ ✿ ✿ ✿ ✿ CHANGE STYLES ON SCROLL ✿ ✿ ✿ ✿ ✿ ✿ ✿  **/

    const mBody = document.getElementsByTagName('body')[0]
    function scrollHeightCheck() {
        window.scrollY >= 100 ? mBody.classList.add('scrolled') 
                         : mBody.classList.remove('scrolled')
    }
    document.onscroll = function() { scrollHeightCheck() }
    scrollHeightCheck()

/** ⇑ ⇑ ⇑ ⇑ ⇑ ⇑ End Change Styles on Scroll ⇑ ⇑ ⇑ ⇑ ⇑ ⇑ **/
